import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { MdBusiness, MdLock } from 'react-icons/md';
import API from '../api';
import { useLanguage } from '../i18n';

export default function ResetPassword() {
    const { t } = useLanguage();
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);

    const submit = async event => {
        event.preventDefault(); setError(''); setMessage('');
        if (password !== confirm) { setError(t('account.passwordsDoNotMatch')); return; }
        setSaving(true);
        try {
            const { data } = await API.post('/auth/reset-password', { token, password });
            setMessage(data.message);
        } catch (err) { setError(err.response?.data?.error || t('account.resetFailed')); }
        finally { setSaving(false); }
    };

    return <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#edf5ff,#b8d6ff)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 18, padding: 32, boxShadow: '0 22px 48px rgba(9,32,64,.18)' }}>
            <div style={{ textAlign: 'center', marginBottom: 24 }}><MdBusiness size={42} style={{ color: '#0b5ed7' }} /><h4 style={{ fontWeight: 700, margin: '8px 0 4px' }}>{t('account.resetTitle')}</h4><p style={{ color: '#64748b', fontSize: 13, margin: 0 }}>{t('account.resetDescription')}</p></div>
            {error && <div className="alert alert-danger py-2" style={{ fontSize: 13 }}>{error}</div>}
            {message ? <><div className="alert alert-success">{message}</div><a href="/login" className="btn btn-primary w-100">{t('account.returnToLogin')}</a></> : <form onSubmit={submit}>
                <label className="form-label" style={{ fontSize: 13 }}>{t('account.newPassword')}</label><div style={{ position: 'relative' }}><MdLock style={{ position: 'absolute', left: 12, top: 11, color: '#94a3b8' }} /><input type="password" className="form-control mb-3" style={{ paddingLeft: 36 }} minLength={12} value={password} onChange={event => setPassword(event.target.value)} required /></div>
                <label className="form-label" style={{ fontSize: 13 }}>{t('account.confirmPassword')}</label><input type="password" className="form-control mb-4" value={confirm} onChange={event => setConfirm(event.target.value)} required />
                <button className="btn btn-primary w-100" disabled={saving}>{saving ? t('account.saving') : t('account.resetPassword')}</button>
            </form>}
        </div>
    </div>;
}
